// open new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  } 
}
//
customElements.define('clearance-product-message', class ClearanceProductMessage extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productJsonUrl = this.getAttribute('data-product-json-url');
    this.onloadVariantId = this.getAttribute('data-onload-variant');
    this.formId = this.getAttribute('data-form-id');
    
    this.updateVisibility(this.onloadVariantId);
    document.addEventListener('variant:change', (event) => {
      if(event.detail.abz_form.getAttribute('id') == this.formId) {
        this.updateVisibility(event.detail.variant.id);
      }
    });
  }

  async updateVisibility(currentVariantId) {
    const response = await fetch(this.productJsonUrl);
    const productJson = await response.json();

    const variant = productJson.product.variants.find((variant) => variant.id == currentVariantId);
    
    variant.price.endsWith('.97') ? this.style.display = 'block': this.style.display = 'none';
  }
});

// Add class in body when shopify chat box opne
  function waitForChatBox(callback) {
    const interval = setInterval(() => {
      const chatBox = document.getElementById("ShopifyChat");
      if (chatBox) {
        clearInterval(interval);
        callback(chatBox);
      }
    }, 300);
  }

  function observeChatOpenState(chatBox) {
    const observer = new MutationObserver(() => {
      const isOpen = chatBox.getAttribute("is-open") === "true";
      if (isOpen) {
        document.body.classList.add("abz-chat-open");
      } else {
        document.body.classList.remove("abz-chat-open");
      }
    });

    observer.observe(chatBox, {
      attributes: true,
      attributeFilter: ["is-open"]
    });

    // Initial check
    const isOpenInitially = chatBox.getAttribute("is-open") === "true";
    if (isOpenInitially) {
      document.body.classList.add("abz-chat-open");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    waitForChatBox(observeChatOpenState);
  });

